import storeConfig from "../../public/store.config.json";

export const STORE = Object.freeze(storeConfig);

export const formatMoney = (amount) =>
  new Intl.NumberFormat(STORE.locale, {
    style: "currency",
    currency: STORE.currency,
    minimumFractionDigits: 2,
  }).format(Number(amount) || 0);

export const checkoutCountries = Object.freeze([
  ["HK", "Hong Kong SAR"],
  ["AU", "Australia"],
  ["AT", "Austria"],
  ["BE", "Belgium"],
  ["CA", "Canada"],
  ["DK", "Denmark"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["DE", "Germany"],
  ["IE", "Ireland"],
  ["IT", "Italy"],
  ["JP", "Japan"],
  ["MO", "Macao SAR"],
  ["MY", "Malaysia"],
  ["NL", "Netherlands"],
  ["NZ", "New Zealand"],
  ["NO", "Norway"],
  ["PT", "Portugal"],
  ["SG", "Singapore"],
  ["KR", "South Korea"],
  ["ES", "Spain"],
  ["SE", "Sweden"],
  ["CH", "Switzerland"],
  ["TW", "Taiwan"],
  ["TH", "Thailand"],
  ["AE", "United Arab Emirates"],
  ["GB", "United Kingdom"],
  ["US", "United States"],
  ["VN", "Vietnam"],
].map(([code, name]) => ({ code, name })));
